import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import { maskFunction } from "../../../util/functions";
import DatePicker from "../../../components/DatePicker";
import { Container, Main } from "../../../components/Container";
import { Row, Col, Form } from "react-bootstrap";
import Checkbox from "../../../components/Checkbox";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import IcMais from "../../../components/Svg/IcMais";
import IcCalendario from "../../../components/Svg/IcCalendario";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";

export default function Business() {
  const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
  const days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

  const locale = {
    localize: {
      month: n => months[n],
      day: n => days[n],
    },
    formatLong: {},
  };

  const defaultItemSchedule = {
    title: "",
    description: "",
    date_start: "",
    date_end: "",
    status: "",
    notification: 1,
    done: 0,
    all_day: false,
  };
  const [itemSchedule, setItemSchedule] = useState(defaultItemSchedule);

  const { stringToDate } = useFormat();

  function handleValueDate(date, nameInput) {
    setItemSchedule({
      ...itemSchedule,
      [nameInput]: date,
    });
  }

  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  function handleRedirect() {
    navigate(`/groups/${commercialId}/registrationdata`);
  }
  const { config } = useWrapper();
  const { commercialId } = useParams();

  const [commercial, setCommercial] = useState({
    institution: {
      title: "",
    },
    course: {
      title: "",
    },
  });
  const [institutions, setInstitutions] = useState([]);
  const [courses, setCourses] = useState([]);
  const [events, setEvents] = useState([]);
  const [packages, setPackages] = useState([]);
  const [singlePackages, setSinglePackages] = useState([]);
  // const [cities, setCities] = useState([]);
  const [trainee, setTrainee] = useState({
    name: "",
    email: "",
    password: "",
    instagram: "",
    cpf: "",
    rg: "",
    ssp: "",
    marital_status: "",
    gender: "",
    date_birth: "",
    phone: "",
    cell: "",
    legal_responsible1: "",
    legal_cell1: "",
    legal_responsible2: "",
    legal_cell2: "",
    cep: "",
    number: "",
    address: "",
    district: "",
    complement: "",
    city_id: "",
    state_id: "",
    due_date: "",
    qtd_invitations: "",
    class_code: "",
    year: "",
    institution_id: "",
    courser_id: "",
    is_whatsapp: 0,
    is_member: 0,
    ssp_state_id: "",
    sendEmail: false,
  });

  const { traineesId } = useParams();

  useEffect(() => {
    loadState();
    loadInstitutions();
    loadCourses();

    if (commercialId) {
      loadBusiness(commercialId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function loadBusiness(commercialId) {
    const response = await api.get(`commercial/${commercialId}`, config);
    setCommercial({
      institution_id: response.data.institution_id,
      courser_id: response.data.courser_id,
      year: response.data.year,
      period: response.data.period,
      max_people: response.data.max_people,
      due_date: stringToDate(response.data.due_date),
      total_trainees: response.data.total_trainees,
      invites_trainees: response.data.invites_trainees,
      ticket_trainees: response.data.ticket_trainees,
      digital_invite: response.data.digital_invite,
      channel_marketing: response.data.channel_marketing,
      min_payment: response.data.min_payment,
      status: response.data.status,
    });

    let arrayEvents = [];
    let arrayPackages = [];

    if (response.data.package !== undefined && response.data.package.length > 0) {
      response.data.package.forEach((item, key) => {
        arrayPackages[key] = {
          number_trainees: item.number_trainees,
          name: item.name,
          events: [],
        };
        if (item.event !== undefined && item.event.length > 0) {
          item.event.forEach(event => {
            arrayPackages[key].events.push(event.id);
            arrayEvents[event.id] = {
              status: true,
              name: event.name,
            };
          });
        }
      });
    }

    let arraySingle = [];
    if (response.data.single !== undefined && response.data.single.length > 0) {
      response.data.single.forEach(item => {
        arrayEvents[item.event.id] = {
          status: true,
          name: item.event.name,
        };

        arraySingle[item.event.id] = {
          checked: true,
          number_trainees: item.number_trainees,
          event_id: item.event.id,
        };
      });
    }

    setPackages(arrayPackages);
    setEvents(arrayEvents);
    setSinglePackages(arraySingle);
  }
  async function loadCourses() {
    const response = await api.get("courses", config);

    setCourses(response.data);
  }

  async function loadInstitutions() {
    const response = await api.get("institutions", config);

    setInstitutions(response.data.data);
  }

  const handleValueString = (event, type = null) => {
    setTrainee({
      ...trainee,
      [event.target.name]: maskFunction(event.target.value, type),
    });
  };

  async function loadState() {
    await api.get("state");
  }

  // async function loadCities(idState) {
  //   const response = await api.get(`cities/${idState}`);
  // }

  const handleValueInt = event => {
    setTrainee({
      ...trainee,
      [event.target.name]: parseInt(event.target.value),
    });
  };

  const handleCheckboxChange = event => {
    setTrainee({
      ...trainee,
      [event.target.name]: event.target.checked,
    });
  };
  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      if (traineesId) {
        editContent(traineesId);
      } else {
        saveContent();
      }
    }

    setValidated(true);
  };
  function renderSinglePackages(data, key) {
    return (
      <div key={`single${key}`} className="avulsasBusiness mt-4">
        <Form.Group className="lince-input list-eventos">
          <Form.Check.Label className="lince-input lince-input__checkbox">
            <div className="checkAvulsas">
              <Checkbox
                name="is_member"
                disabled
                checked={singlePackages[key] !== undefined ? singlePackages[key].checked : false}
                className="lince-input__checkbox__check"
              />
              <span className="lince-input_label">{data.name}</span>
            </div>
            <div className="quantAvulsas">
              <Form.Control
                type="text"
                disabled
                required={singlePackages[key] !== undefined ? singlePackages[key].checked : false}
                name="number_trainees"
                value={singlePackages[key] !== undefined ? singlePackages[key].number_trainees : ""}
              />
              <span>formandos</span>
            </div>
          </Form.Check.Label>
        </Form.Group>
      </div>
    );
  }
  async function editContent(traineesId) {
    try {
      await api.put(
        `trainees/${traineesId}`,
        {
          name: trainee.name,
          email: trainee.email,
          instagram: trainee.instagram,
          cpf: trainee.cpf,
          rg: trainee.rg,
          ssp: trainee.ssp,
          marital_status: trainee.marital_status,
          gender: trainee.gender,
          date_birth: trainee.date_birth,
          phone: trainee.phone,
          cell: trainee.cell,
          legal_responsible1: trainee.legal_responsible1,
          legal_cell1: trainee.legal_cell1,
          legal_responsible2: trainee.legal_responsible2,
          legal_cell2: trainee.legal_cell2,
          cep: trainee.cep,
          number: trainee.number,
          address: trainee.address,
          district: trainee.district,
          complement: trainee.complement,
          city_id: trainee.city_id,
          state_id: trainee.state_id,
          due_date: trainee.due_date,
          qtd_invitations: trainee.qtd_invitations,
          class_code: trainee.class_code,
          year: trainee.year,
          password: trainee.password,
          institution_id: trainee.institution_id,
          courser_id: trainee.courser_id,
          is_whatsapp: trainee.is_whatsapp,
          is_member: trainee.is_member,
          ssp_state_id: trainee.ssp_state_id,
        },
        config,
      );

      toast.success("Conteúdo salvo com sucesso!");
      navigate(`/trainees`);
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }

  async function saveContent() {
    try {
      await api.post(
        "trainees",
        {
          name: trainee.name,
          email: trainee.email,
          password: trainee.password,
          instagram: trainee.instagram,
          cpf: trainee.cpf,
          rg: trainee.rg,
          ssp: trainee.ssp,
          marital_status: trainee.marital_status,
          gender: trainee.gender,
          date_birth: trainee.date_birth,
          phone: trainee.phone,
          cell: trainee.cell,
          legal_responsible1: trainee.legal_responsible1,
          legal_cell1: trainee.legal_cell1,
          legal_responsible2: trainee.legal_responsible2,
          legal_cell2: trainee.legal_cell2,
          cep: trainee.cep,
          number: trainee.number,
          address: trainee.address,
          district: trainee.district,
          complement: trainee.complement,
          city_id: trainee.city_id,
          state_id: trainee.state_id,
          due_date: trainee.due_date,
          qtd_invitations: trainee.qtd_invitations,
          class_code: trainee.class_code,
          year: trainee.year,
          institution_id: trainee.institution_id,
          courser_id: trainee.courser_id,
          is_whatsapp: trainee.is_whatsapp,
          is_member: trainee.is_member,
          ssp_state_id: trainee.ssp_state_id,
        },
        config,
      );

      toast.success("Conteúdo salvo com sucesso!");
      navigate(`/trainees`);
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }

  return (
    <Main>
      <Container className="inner-page">
        <Row>
          <Col>
            <h2 className="titlePage">Dados da Turma</h2>
          </Col>
          <Col className="text-right d-flex justify-content-end">
            <button className="btnGhost small iconPlus">
              <div className="icon">
                <IcMais />
              </div>
              Nova Festividade Avulsa
            </button>
          </Col>
        </Row>
        <Form className="formBusiness" noValidate validated={validated} id="traineeForm" onSubmit={handleSubmit}>
          <Row className="inner-page__sbs-border mt-3">
            <Col md={6} className="pr-md-5">
              <Row>
                <Col>
                  <h3 className="subtitleFormSec">Dados da Turma</h3>
                  <Form.Check.Label className="lince-input">
                    <span className="lince-input_label">Instituição</span>
                    <div className="lince-input__select">
                      <Form.Control
                        value={commercial.institution_id || ""}
                        disabled
                        required
                        as="select"
                        onChange={handleValueInt}
                        name="institution_id"
                      >
                        <option value=""></option>
                        {institutions.length > 0 &&
                          institutions.map(institution => (
                            <option key={`institution-${institution.id}`} value={institution.id}>
                              {institution.title}
                            </option>
                          ))}
                      </Form.Control>
                    </div>
                  </Form.Check.Label>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Curso</span>
                      <div className="lince-input__select">
                        <Form.Control
                          value={commercial.courser_id || ""}
                          disabled
                          required
                          as="select"
                          onChange={handleValueInt}
                          name="courser_id"
                        >
                          <option value=""></option>
                          {courses.length > 0 &&
                            courses.map(course => (
                              <option key={`course-${course.id}`} value={course.id}>
                                {course.title}
                              </option>
                            ))}
                        </Form.Control>
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
                <Col className="flex">
                  <Form.Check.Label className="lince-input wd75">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Ano/Período</span>
                      <div className="lince-input__text">
                        <Form.Control
                          type="text"
                          required
                          disabled
                          onChange={handleValueString}
                          name="year"
                          value={commercial.year}
                        />
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                  <Form.Check.Label className="lince-input ltSelect">
                    <span className="lince-input_label">&nbsp;</span>
                    <div className="lince-input__select">
                      <Form.Control
                        disabled
                        value={commercial.period || ""}
                        required
                        as="select"
                        onChange={handleValueString}
                        name="period"
                      >
                        <option value=""></option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                      </Form.Control>
                    </div>
                  </Form.Check.Label>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <h3 className="subtitleFormSec">Dados do Contrato</h3>
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Data de Início das Solenidades</span>
                      <div className="inputIcon">
                        <div className="lince-input__text">
                          <DatePicker
                            required
                            selected={commercial.due_date}
                            changeDate={date => handleValueDate(date, "due_date")}
                          />
                          <IcCalendario />
                        </div>
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Qnt. Máxima de Parcelas</span>
                      <div className="lince-input__text">
                        <Form.Control
                          required
                          disabled
                          type="text"
                          onChange={event => handleValueString(event, "numeric")}
                          name="min_payment"
                          value={commercial.min_payment}
                        />
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Total de formandos</span>
                      <div className="lince-input__text">
                        <Form.Control
                          required
                          disabled
                          type="text"
                          onChange={handleValueString}
                          name="total_trainees"
                          value={commercial.total_trainees}
                        />
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Convites por formando</span>
                      <div className="lince-input__text">
                        <Form.Control
                          required
                          disabled
                          type="text"
                          onChange={event => handleValueString(event, "numeric")}
                          name="invites_trainees"
                          value={commercial.invites_trainees}
                        />
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Ingressos por formando</span>
                      <div className="lince-input__text">
                        <Form.Control
                          required
                          type="text"
                          disabled
                          onChange={handleValueString}
                          name="ticket_trainees"
                          value={commercial.ticket_trainees}
                        />
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
                <Col>
                  <Form.Check.Label className="lince-input">
                    <Form.Group className="lince-input">
                      <span className="lince-input_label">Incluir Convite Digital?</span>
                      <div className="lince-input__text">
                        <Form.Check.Label className="lince-input lince-input__checkbox d-inline-block checkFormBusiness">
                          <Checkbox
                            name="digital_invite"
                            disabled
                            checked={commercial.digital_invite || 0}
                            onChange={event => handleCheckboxChange(event)}
                            className="lince-input__checkbox__check"
                          />
                          <span className="lince-input_label fs-12">Sim</span>
                        </Form.Check.Label>
                      </div>
                    </Form.Group>
                  </Form.Check.Label>
                </Col>
              </Row>
            </Col>
            <Col md={6} className="pl-md-5">
              {packages.length > 0 &&
                packages.map((item, index) => (
                  <div key={`packagemain${index}`} className="pacote mt-3">
                    <Row>
                      <Col>
                        <h3 className="subtitleFormSec">Pacote {index + 1}</h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="lince-input">
                          <span className="lince-input_label">Nome do Pacote</span>
                          <div className="lince-input__text">
                            <Form.Control
                              type="text"
                              required
                              disabled
                              name="name"
                              value={packages[index].name || ""}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="lince-input">
                          <span className="lince-input_label">Quantidade de Formandos</span>
                          <div className="lince-input__text">
                            <Form.Control
                              type="text"
                              required
                              disabled
                              name="number_trainees"
                              value={packages[index].number_trainees || ""}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="lince-input m-0">
                          <span className="lince-input_label">Festividades Inclusas</span>
                          <div className="tags textareaTags">
                            <ul>
                              {Object.keys(events).length > 0 &&
                                Object.keys(events).map((value, key) => {
                                  if (events[value].status === true) {
                                    if (packages[index].events.indexOf(parseInt(value)) > -1) {
                                      return (
                                        <li key={`inactive${value + key}`} className="active">
                                          {events[value].name}
                                        </li>
                                      );
                                    }
                                  }
                                })}
                            </ul>
                          </div>
                          <div className="tags outsideTags">
                            <ul>
                              {Object.keys(events).length > 0 &&
                                Object.keys(events).map((value, key) => {
                                  if (events[value].status === true) {
                                    if (packages[index].events.indexOf(parseInt(value)) === -1) {
                                      return (
                                        <li key={`inactive${value + key}`} className="active">
                                          {events[value].name}
                                        </li>
                                      );
                                    }
                                  }
                                })}
                            </ul>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                ))}
              <Row className="mt-3">
                <Col>
                  <h3 className="subtitleFormSec">Festividades Avulsas</h3>
                  {Object.keys(events).length > 0 &&
                    Object.keys(events).map(value => {
                      if (events[value].status === true) {
                        return renderSinglePackages(events[value], value);
                      }
                    })}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="inner-page__actions mt-5">
            <Col className="-space-between">
              <div className="inner-page__actions__group">
                <button onClick={() => handleRedirect()} className="btn-lince btn-lince-ghost" type="button">
                  Voltar
                </button>
                <button type="button" className="btn-lince btn-lince-ghost-red">
                  Desativar Turma
                </button>
              </div>
              <div className="inner-page__actions__group">
                <button className="btn-lince btnSave" type="button">
                  Salvar
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </Container>
    </Main>
  );
}
